module.exports = __webpack_public_path__ + "img/dictionary-purple.49030a12.svg";